/**
 * Location switcher
 */
app.location = (function() {
    "use strict";
    var $toggle,
        $chooser,
        $select,
        locations = null,
        cultureCode,
        locationCode,
        parent,
        customEnrollment = false,
        callback = false,
        page = 'default',
        self = {

        init: function(pageName) {

            if (pageName == 'home') {
                page = pageName;
                parent = app.home;
                // this triggers the loading of countries.json
                //self.setLocations();

            } else {
                parent = app.main;
            }

            $toggle = $('#location-toggle');
            $chooser = $('#location-chooser');
            cultureCode = parent.getCurrentCulture();
            locationCode = parent.getCountryCode();

            //if (page == 'default') {
                parent.getTemplate('location-chooser', {}, true, self.render);
            //}
        },

        /**
         * Called after the external template has finished loading
         */
        render: function() {
            self.applyRebrand();

            // special case for Indonesia as enrollment is not currently enabled
            // if (customEnrollment === true) {
            //     locations.id.disabled = true;
            // }

            var data = {
                currentLocation: locationCode,
                currentCode: cultureCode,
                locations: locations,
                languages: locations[locationCode].languages,
                customEnrollment: customEnrollment
            };

            if (page == 'default') {
                data.currency = app.global.currency(false, locationCode);
            }

            $chooser.html(parent.getTemplate('location-chooser', data));

            $toggle.off('click').on('click', function(e) {
                e.stopPropagation();
                e.preventDefault();
                self.toggle();
            });

            // disallow clicking to trigger the document click handler
            $chooser.off('click').on('click', function(e) {
                e.stopPropagation();
            });

            // init the auto-complete select plugin
            try {
                $select = $('#field-location').selectize({
                    allowEmptyOption: false,
                    openOnFocus: true,
                    selectOnTab: false
                });

                $select[0].selectize.on('focus', function(e) {
                    $select[0].selectize.clear();
                });

                $select[0].selectize.on('blur', function(e) {
                    // slight delay to avoid blur event when a legit item is selected
                    setTimeout(function() {
                        if (!$('#field-location').val()) {
                            $select[0].selectize.setValue(locationCode);
                        }
                    }, 100);
                });

            } catch(err) {
                
            }

            $('#field-location').off('change').on('change', function(e) {
                if ($(this).val() == false) {
                    return;
                }

                try {
                    if (locationCode != $(this).val()) {
                        app.main.track('Culture Switcher', 'switches-country', $(this).val());
                    }

                } catch(err) {
                    //console.log('Tracking is not available');
                }

                if (callback) {
                    callback($(this).val());
                }

                if (customEnrollment === true && $(this).val() == 'other') {
                    self.toggle('close');
                    return;
                }

                self.populateLanguages($(this).val());
            });

            $('#field-language').off('change').on('change', function(e) {
                self.setCurrency();

                try {
                    app.main.track('Culture Switcher', 'switches-language', $(this).val());

                } catch(err) {
                    //console.log('Tracking is not available');
                }
            });

            $('#btn-cancel-location').off('click').on('click', function() {
                try {
                    app.main.track('Culture Switcher', 'cancels', $('#field-location').val() +'|'+ $('#field-language').val());

                } catch(err) {
                    //console.log('Tracking is not available');
                }

                self.toggle('close');
            });

            $('#btn-save-location').off('click').on('click', function() {
                var cookie = app.cookie.get(),
                    cookieData = {};

                if (cookie) {
                    cookieData = JSON.parse(cookie);
                }

                cookieData.country = $('#field-location').val();
                cookieData.culture = $('#field-language').val();
                app.cookie.set(JSON.stringify(cookieData));

                // force refresh to reload products/categories on member page
                if (page == 'default') {
                    // window.location.reload();
                    // return;
                }

                if (['default', 'home'].includes(page)) {
                    try {
                        app.main.track('Culture Switcher', 'saves', $('#field-location').val() +'|'+ $('#field-language').val());

                    } catch(err) {
                        //console.log('Tracking is not available');
                    }

                    if (customEnrollment) {
                        // let the enrollment module do whatever it needs to do
                        callback('reset');
                    }

                    // if using the custom enrollment switcher, clear products to on switch the appropriate product list will load
                    if (customEnrollment) {
                        app.enroll.clearProducts();
                    }

                    parent.loadLanguageData($('#field-language').val());

                } else {
                    window.location.replace('#'+ cookieData.culture);
                }

                try {
                    app.cart.clear();

                } catch(err) {
                    //console.log('Add to cart not present.');
                }

            });
        },

        /**
         * Apply or disable rebrand per region/page
         */
        applyRebrand: function(disable) {
            if (parent.getSettings().rebrand_enabled && disable !== true) {
                // special hook to load rebrand styling for specific regions
                // only add if not already added
                if (!$('#rebrand-css').length) {
                    $('<link>')
                        .appendTo('head')
                        .attr({
                            id: 'rebrand-css',
                            type: 'text/css',
                            rel: 'stylesheet',
                            href: '/css/rebrand.css' + cb
                        });

                    if (parent.getSettings().unified_shopping_enabled) {
                        $('body').addClass('unified-shopping');
                    }
                }
            } else {
                // remove the rebrand if previously added
                $('#rebrand-css').remove();
                $('body').removeClass('unified-shopping');
            }
        },

        /**
         * Ideally, this module would load countries.json, but until then it's passed from parent.loadLanguageData
         */
        setLocations: function(cultures) {
            if (typeof cultures == 'object') {
                locations = cultures;

            } else {
                // for non-pws pages like the home page, load country data
                $.getJSON(assetURL[mode] +'json/countries.json', function(data) {
                    locations = data;
                    parent.getTemplate('location-chooser', {}, true, self.render);
                });
            }
        },

        /**
         * Enrollment has a different toggle
         */
        setToggle: function(id) {
            $toggle = $('#'+ id);
            self.reset();
        },

        /**
         * Enrollment needs a special 'other' option at the end of the location select
         * Requires a callback function that triggers when 'other' is selected
         */
        enableCustomEnrollment: function(cback) {
            customEnrollment = true;

            if (typeof cback == 'function') {
                callback = cback;
            }
        },

        /**
         * Open/close chooser dialog
         */
        toggle: function(force) {
            if ($chooser.hasClass('is-active') || force == 'close') {
                $chooser.removeClass('is-active');
                $toggle.removeClass('is-active');

                $(document).off('click');

                // if 'other' was selected (customEnrollment == true) then don't reset so the user can go back and select another
                if ($('#field-location') == 'other') {
                    self.reset();
                    return;
                }

                // reset to the original value
                $select[0].selectize.setValue(locationCode);

            } else {
                $chooser.addClass('is-active');
                $toggle.addClass('is-active');
                $(document).on('click', function() {
                    self.toggle('close');
                    $(document).off('click');
                });
                self.setCartWarning();

                try {
                    app.main.track('Culture Switcher', 'clicks-to-view', locationCode);

                } catch(err) {
                    //console.log('Tracking is not available');
                }

                try {
                    app.cart.hideIfVisible();

                } catch(err) {
                    //console.log('Add to cart not present.');
                }
            }
        },

        /**
         * Clears and re-adds languages to the select field for the chosen location
         */
        populateLanguages: function(locationCode) {
            var languages = locations[locationCode].languages;

            if (languages) {
                $('#field-language').empty();

                languages.forEach(function(language) {
                    // exclude 'eu' because it isn't a country
                    //if (language.code.split('-')[1] != 'eu') {
                        $('#field-language').append('<option value="'+ language.code +'">'+ language.language +'</option>');
                    //}
                });

                self.setCurrency();

                $('#field-language').prop('disabled', false);
                $('#btn-save-location').removeClass('is-disabled');

            } else {
                $('#field-language').prop('disabled', true);
                $('#btn-save-location').addClass('is-disabled');
            }
        },

        /**
         * Sets the currency label when the location or language changes
         */
        setCurrency: function() {
            if (page != 'default') return;

            var currency = app.global.currency(false, $('#field-location').val());
            $('#currency span').text(currency.symbol +' '+ currency.label);
        },

        /**
         * Set to hide or show the cart warning copy
         */
        setCartWarning: function() {
            var show = false;

            try {
                // new cart
                if (app.cart.hasItems()) {
                    show = true;
                }

            } catch (err) {
                //console.log('Add to cart not present.');
            }

            // old cart
            // todo: delete once new cart goes live
            if (parseInt($('header .notification-qty').text(), 10) > 0) {
                show = true;
            }

            if (customEnrollment == true) {
                if (app.enroll.hasItems()) {
                    show = true;
                }
            }

            $('.cart-warning').toggleClass('is-active', show);
        },

        /**
         * Get a language item from the culture code
         * todo: move more of these location based queries from app.main into this module
         * getCurrentCulture(), getCountryCode(), etc.
         */
        getCurrentLanguage: function() {
            try {
                var cultures = locations[locationCode].languages;

                for (var i=0; i<cultures.length; i++) {
                    if (cultures[i].code == cultureCode) {
                        return cultures[i];
                        //break;
                    }
                }
            } catch (err) {
                console.log('Unable to load languages for '+ locationCode);
            }
            return false;
        },

        /**
         * Return the current location (country code)
         */
        getCurrentLocation: function() {
            return locationCode;
        },

        /**
         * Resets the form to current location/language if cancelled or closed after seleting options
         */
        reset: function() {
            // let's see if we can get away with render()
            self.render();
        }
    };

    return self;
}());
